import type { FlowGraphNode } from '../api/contracts';

/**
 * A donde lleva pinchar un paso del grafo.
 *
 * LA REGLA: si el paso es un solo mensaje, se va derecho a ese evento —pedir un
 * clic mas para elegir entre una sola opcion es friccion pura—. Si el paso corrio
 * varias veces no hay un destino unico, asi que primero se muestran sus mensajes
 * y elige quien mira. Un paso que no ocurrio tampoco tiene a donde ir: se abre su
 * ficha para explicar por que esta en gris.
 */
export type StepTarget =
  { readonly kind: 'message'; readonly messageId: string } | { readonly kind: 'panel' };

export function resolveStepTarget(step: FlowGraphNode): StepTarget {
  const [first] = step.messageIds;
  if (step.messageCount === 1 && first !== undefined) {
    return { kind: 'message', messageId: first };
  }
  return { kind: 'panel' };
}
